var _ellipse, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _ellipse2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSampleRequestError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 90,
    viewBox: "0 0 62 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5,
    cy: 80.1631,
    rx: 23.5,
    ry: 1.5,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0003 14.4L58.6003 12L55.0001 15.6001L51.4 12L49 14.4L52.6001 18.0002L49.0003 21.6L51.4003 24L55.0001 20.4002L58.6 24.0001L61 21.6L57.4002 18.0002L61.0003 14.4Z",
    fill: "#EC4C47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 12L8.00025 10L5.00013 13.0001L2.00001 10L0 12L3.00012 15.0001L0.000212932 18L2.00022 20L5.00013 17.0001L8.00004 20.0001L10 18L7.00014 15.0001L10.0003 12Z",
    fill: "#EC4C47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0702 3.75738L34.2417 0.928955L29.9989 5.17175L25.7562 0.928967L22.9277 3.75739L27.1705 8.00018L22.928 12.2427L25.7565 15.0711L29.9989 10.8286L34.2414 15.0711L37.0699 12.2427L32.8274 8.00018L37.0702 3.75738Z",
    fill: "#EC4C47"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.0098,
    y: 23,
    width: 41,
    height: 40,
    transform: "rotate(10.9286 18.0098 23)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6289,
    y: 30.4414,
    width: 35,
    height: 26,
    transform: "rotate(10.9286 19.6289 30.4414)",
    fill: "#713CDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 49.6865,
    width: 41,
    height: 40,
    transform: "rotate(-22.4365 0 49.6865)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.44531,
    y: 55.0117,
    width: 35,
    height: 26,
    transform: "rotate(-22.4365 5.44531 55.0117)",
    fill: "#B697F4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.5,
    cy: 88.5,
    rx: 23.5,
    ry: 1.5,
    fill: "url(#paint1_linear)",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7876 62.8079L22.4855 68.3342C21.4236 68.7759 20.1976 68.4676 19.4711 67.576C18.7445 66.6844 18.6901 65.4214 19.3371 64.4705L24.2043 57.3082L25.4726 55.3448C26.0637 54.4453 25.9531 53.8361 25.8357 53.5536C25.5562 52.8808 24.7868 52.5302 24.1552 52.7894L24.1487 52.7921C23.5192 53.0514 23.2089 53.7634 23.4476 54.4011C23.5279 54.6183 23.4861 54.8619 23.3381 55.0401C23.19 55.2182 22.9582 55.3038 22.7299 55.2647C22.5016 55.2255 22.3115 55.0676 22.2313 54.8503C21.7489 53.5602 22.3771 52.1201 23.6507 51.596L23.6636 51.5906C24.9631 51.0583 26.4749 51.7178 27.0313 53.0569C27.2469 53.576 27.4737 54.657 26.5575 56.0521L25.289 58.0177L25.2801 58.03L20.4109 65.203C20.0906 65.6797 20.1197 66.3098 20.4827 66.755C20.8456 67.2001 21.457 67.3555 21.9884 67.1377L35.2906 61.6114C35.8202 61.3889 36.142 60.846 36.0828 60.2745C36.0237 59.703 35.5977 59.2375 35.0337 59.128L27.3859 57.6851C27.0363 57.6168 26.8074 57.279 26.8735 56.929C26.9397 56.579 27.2761 56.348 27.6265 56.412L35.273 57.8544C36.4003 58.0696 37.2533 58.9983 37.3719 60.1399C37.4905 61.2814 36.8467 62.3657 35.7876 62.8079Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11,
    y1: 80.1631,
    x2: 55,
    y2: 80.1631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15,
    y1: 88.5,
    x2: 59,
    y2: 88.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.789,
    height: 27.7065,
    fill: "white",
    transform: "translate(3.25391 53.552) rotate(-22.56)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleRequestError);
export default __webpack_public_path__ + "static/media/sampleRequestError.a38d6550.svg";
export { ForwardRef as ReactComponent };